import { lang } from '@umu/ukit-lang';
import { safeJSONParse } from '../../@utils/jsonParse';
import { DimensionType, IAiDimension, IAiDimensionData, TagColor, IKeyVal } from './types';
export const VALID_AVG_VAL = 4.5; // 起评分，低于这个分则另作处理

const DIMENSION_STRINGS: { [key in DimensionType]: string[] } = {
    volume: [
        lang('清晰明亮'),
        lang('清楚悦耳'),
        lang('字正腔圆'),
        lang('朗朗动听'),
        lang('穿透力强'),
        lang('声卡战士'),
    ], // 音量
    speed: [lang('沉稳淡定'), lang('不疾不徐'), lang('婉转平和'), lang('娓娓道来'), lang('侃侃而谈'), lang('条理清晰')], // 语速
    smooth: [lang('妙语连珠'), lang('出口成章'), lang('口齿伶俐'), lang('逻辑性强'), lang('独当一面')], // 流畅度
    sight: [lang('炯炯有神'), lang('炽热真诚'), lang('深邃坚定'), lang('目不斜视'), lang('聚精会神'), lang('气定神闲')], // 眼神
    smile: [lang('颜值担当'), lang('谈笑风生'), lang('魅力榜样'), lang('人见人爱'), lang('温暖治愈')], // 微笑
    gesture: [lang('干净利落'), lang('情绪饱满'), lang('神态自若'), lang('有板有眼'), lang('绘声绘色')], // 手势
};

const REST_STRINGS_FOR_DIMENTIONS = [
    lang('胸有成竹'),
    lang('自信满满'),
    lang('如沐春风'),
    lang('感染力强'),
    lang('引人入胜'),
    lang('才华横溢'),
    lang('身临其境'),
    lang('未来无限'),
    lang('明日之星'),
];

// "Voice clear increase shortcoming" = "如果可以增大音量，能表现得更好。";
// "Voice clear decrease shortcoming" = "如果可以减小音量，能表现得更好。";
// "Voice speed fast shortcoming" = "如果可以加快语速，能表现得更好。";
// "Voice speed slow shortcoming" = "如果可以放慢语速，能表现得更好。";
// "Word fluency shortcoming" = "如果可以减少卡顿，增强语言的连贯性，能表现得更好。";
// "Self confidence shortcoming" = "如果可以多注视镜头，留意目光的交流，就更好了。";
// "Smile affinity shortcoming" = "如果可以保持微笑，注意表情，就更好了。";
// "Gestures shortcoming" = "如果可以加些手势来辅助表达，能表现得更好。";

export const OVERVIEW_STRINGS: { [props: string]: string } = {
    volume: lang('你的声音清晰明亮，婉转动听，感染力强，是一位不可多得的演说家。'), // 音量
    speed: lang('你说话不急不慢，语速恰当，听你谈话如沐春风。'), // 语速
    smooth: lang('你语言流畅，思路清晰，敏捷过人，具备超强的逻辑思维。'), // 流畅度
    sight: lang('你是一位自信的讲者，笃定的目光背后，是熟练的技巧，和坚定的内心。'), // 眼神
    smile: lang('你总是保持微笑，犹如阳光照耀他人，亲和而有力量。'), // 微笑
    gesture: lang('你很会表达自己，善用手势，积极热情，表现力强。'), // 手势
};

export const TAG_COLORS = ['red', 'blue', 'orange'];

// /**
//  * 三个标签的展示：
//  * 分数>=4.5
//  * 6个维度中，分数最高的2个维度，每一个随机取一个词。如果有分数相同的维度，随机取维度。
//  * 剩下的1个词在整体分数区间的词中随机取1个。
//  * 分数<4.5
//  * 不出标签和推荐语
//  */
// export const getTags = (dimensions: IAiDimension[]): ITagWithColor[] => {
//   const max2 = getMax2(dimensions);
//   const maxRandom1 = getRandomItemFromArray<string>(
//     DIMENSION_STRINGS[max2[0].type],
//   );
//   const maxRandom2 = getRandomItemFromArray<string>(
//     DIMENSION_STRINGS[max2[1].type],
//   );
//   const randomString = getRandomItemFromArray<string>(
//     REST_STRINGS_FOR_DIMENTIONS,
//   );
//   const tagColors = shffuleArr(TAG_COLORS as TagColor[]);
//   return [
//     {
//       tag: maxRandom1,
//       color: tagColors[0],
//     },
//     {
//       tag: maxRandom2,
//       color: tagColors[1],
//     },
//     {
//       tag: randomString,
//       color: tagColors[2],
//     },
//   ];
// };

export const getShuffledTagColors = () => {
    return shffuleArr(TAG_COLORS as TagColor[]);
};

export const getTags = (labelIds: string[] = []): string[] => {
    if (labelIds.length === 0) {
        return [];
    }

    return labelIds.map((labelId) => {
        const extractedLabel = labelId.split('_');
        if (extractedLabel.length < 2) {
            // 非法的数据
            return '';
        }
        const dimension = extractedLabel[0] as DimensionType | 'random';
        const stringIndex = +extractedLabel[1];
        if (dimension === 'random') {
            return REST_STRINGS_FOR_DIMENTIONS[stringIndex];
        }
        return DIMENSION_STRINGS[dimension][stringIndex];
    });
};

// /**
//  * 从数组中随机取一个元素
//  *
//  * @template T
//  * @param {T[]} array
//  * @returns {T}
//  */
// function getRandomItemFromArray<T>(array: T[]): T {
//   return array[Math.floor(Math.random() * array.length)];
// }

/**
 * 从所有维度中找出最值最大的
 */
export function getMax(dimensions: IAiDimension[] = []): IAiDimension {
    if (dimensions.length === 0) {
        return {
            value: 0,
            type: 'volume',
        };
    }
    dimensions = dimensions.slice();
    const max = dimensions.reduce((prev, current) => {
        if (prev.value > current.value) {
            return prev;
        } else {
            return current;
        }
    });
    return max;
}

// /**
//  * 从所有维度中找出最值最大的两个
//  *
//  * @param {IAiDimension[]} dimensions
//  * @returns {IAiDimension[]}
//  */
// function getMax2(dimensions: IAiDimension[]): IAiDimension[] {
//   dimensions = dimensions.slice();
//   let maxIndex = 0;
//   const max1 = dimensions.reduce(function(prev, current, index) {
//     if (prev.value > current.value) {
//       return prev;
//     } else {
//       maxIndex = index;
//       return current;
//     }
//   });
//   dimensions.splice(maxIndex, 1);
//   const max2 = dimensions.reduce(function(prev, current, index) {
//     if (prev.value > current.value) {
//       return prev;
//     } else {
//       maxIndex = index;
//       return current;
//     }
//   });
//   return [max1, max2];
// }

export const shffuleArr = (arr: TagColor[]): TagColor[] => {
    return arr.sort((_a: string, _b: string) => {
        return Math.random() - 0.5;
    });
};

/**
 * 过滤掉权重为0的dimension
 */
export const filterDimensions = (
    dimensions: IAiDimensionData,
    weight: string,
    maxDimension?: number,
): IAiDimensionData => {
    maxDimension = maxDimension || 10;

    if (!dimensions) {
        dimensions = { volume: 10, speed: 10, smooth: 10, sight: 10, smile: 10, gesture: 10 };
    }

    let weightObj: { [prop: string]: { weight: number } } = {
        volume: { weight: 10 },
        speed: { weight: 10 },
        smooth: { weight: 10 },
        sight: { weight: 10 },
        smile: { weight: 10 },
        gesture: { weight: 10 },
    };
    if (weight) {
        weightObj = safeJSONParse(weight, weightObj) as { [prop: string]: { weight: number } };
    }

    let keys = Object.keys(dimensions);
    // 权重都大于0的才参与均值计算
    keys = keys.filter((key) => {
        return weightObj && weightObj[key] && weightObj[key].weight > 0;
    });
    if (keys.length === 0) {
        return dimensions;
    }

    // tslint:disable-next-line: no-shadowed-variable
    const filteredDimensions: { [index: string]: number } = {};
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        filteredDimensions[key] = Math.max(0, Math.min(maxDimension, dimensions[key] || 0));
    }
    return filteredDimensions as IAiDimensionData;
};

/**
 * 计算均值
 */
export const calclulateAvg = (
    dimensions?: IAiDimensionData,
    weight?: string,
    allow_ytmw_cal_to_score: number = 0,
    ytmw_def_val: number = 0,
): number => {
    if (!dimensions) {
        return 0;
    }
    const isAllZero = Object.values(dimensions).every((item) => item == 0);
    // 全是一团迷雾则总分为0
    if (isAllZero) {
        return 0;
    }
    const newDimensions = { ...dimensions };

    let weightObj: { [prop: string]: { weight: number } } = {
        volume: { weight: 10 },
        speed: { weight: 10 },
        smooth: { weight: 10 },
        sight: { weight: 10 },
        smile: { weight: 10 },
        gesture: { weight: 10 },
    };
    // 没有weight时，默认权重相等
    if (weight) {
        weightObj = safeJSONParse(weight, weightObj) as { [prop: string]: { weight: number } };
    }

    let keys = Object.keys(newDimensions);

    // 将一团迷雾即0分重新赋值为ywmw_def_val并加入到计算中
    if (allow_ytmw_cal_to_score == 1) {
        keys.forEach((key) => {
            if (!newDimensions[key]) {
                newDimensions[key] = ytmw_def_val;
            }
        });
    }
    // 维度和权重都大于0的才参与均值计算
    keys = keys.filter((key) => {
        return newDimensions[key] > 0 && weightObj && weightObj[key] && weightObj[key].weight > 0;
    });
    if (keys.length === 0) {
        return 0;
    }

    // 权重数据规范
    // tslint:disable-next-line: no-shadowed-variable
    const filteredWeight: { [index: string]: number } = {};
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        filteredWeight[key] = Math.max(0, Math.min(10, (weightObj && weightObj[key] && weightObj[key].weight) || 0));
    }

    // 计算权重总和
    let weightSum = 0;
    for (let i = 0; i < keys.length; i++) {
        weightSum += +filteredWeight[keys[i]];
    }

    let avg = 0;
    for (let i = 0; i < keys.length; i++) {
        avg += (+newDimensions[keys[i]] * filteredWeight[keys[i]]) / weightSum;
    }
    return Number((Math.round(avg * 10) / 10).toFixed(1));
};

// AI 报告中的六个评价维度的枚举
export const AI_DIMENTION: IKeyVal = {
    VOLUME: 'volume',
    SPEED: 'speed',
    SMOOTH: 'smooth',
    SIGHT: 'sight',
    SMILE: 'smile',
    GESTURE: 'gesture',
};
